export default "<div class=\"hints\">\n  <ng-content></ng-content>\n</div>\n";